import React from "react";
import PropTypes from "prop-types";
import { TextField } from "@mui/material";
import { ErrorMessage } from "formik";

const TextInputField = ({
  label,
  field,
  form,
  className,
  ...rest
}) => {
  const errorId = `${field.name}-error`;
  const hasError = form.errors[field.name] && form.touched[field.name];

  return (
    <div className={className}>
      <span className="form-field-header">
        {label && <label className="form-field-label" htmlFor={field.name}>{label}</label>}
      </span>
      <span
        id={errorId}
        className="form-field-error"
        role="alert"
        aria-live="polite"
      >
        <ErrorMessage name={field.name} />
      </span>
      <TextField
        id={field.name}
        name={field.name}
        value={field.value}
        className="input-field"
        onChange={form.handleChange}
        onBlur={field.onBlur}
        margin="dense"
        style={{ width: "100%" }}
        error={hasError}
        inputProps={{
          'aria-describedby': hasError ? errorId : undefined,
          'aria-invalid': hasError
        }}
        {...rest}
      />
    </div>
  );
};

TextInputField.propTypes = {
  label: PropTypes.string.isRequired,
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    onBlur: PropTypes.func
  }),
  form: PropTypes.shape({
    handleChange: PropTypes.func
  }).isRequired,
  className: PropTypes.string
};

TextInputField.defaultProps = {
  className: "form-field"
};

export default TextInputField;
